export default "__VITE_ASSET__BqlLXq$B__"